import {createRootContextHook} from 'common/util/react';

export const useEventsController = createRootContextHook(`eventsController`);
